import React, { useEffect, useState } from "react";
import UpdateReviewForm from "../../../Forms/UpdateReview";
import { BiLoaderAlt } from "react-icons/bi";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { reviewDetails } from "../../../../stores/actions/review.actions.types";
import MetaHead from "../../../Common/Metahead";
import { useTranslation } from "react-i18next";

const UpdateReview = ({ reviewDetails, loading }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [review, setReview] = useState(null);

  useEffect(() => {
    if (id) {
      reviewDetails({
        id,
        callback: (data) => {
          if (data?.success) {
            setReview(data?.data?.review);
          }
        },
      });
    }
  }, [id, reviewDetails]);

  if (loading) {
    return (
      <div className='flex m-6 dark:bg-boxdark rounded-[10px] bg-white items-center justify-center min-h-96'>
        <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
      </div>
    );
  }

  return (
    <div>
      <MetaHead title={t("Review Update")} />
      <UpdateReviewForm ReviewData={review} />
    </div>
  );
};

const mapStateToProps = (state) => ({ loading: state?.app?.visible });
export default connect(mapStateToProps, { reviewDetails })(UpdateReview);
